const FETCH_CURATIONS = 'home/FETCH_CURATIONS';

const FETCH_CURATIONS_BANNERS = 'home/FETCH_CURATIONS_BANNERS';

const FETCH_STORIES = 'home/FETCH_STORIES';

const FETCH_SECTIONS = 'home/FETCH_SECTIONS';

const REFRESH_STORIES = 'home/REFRESH_STORIES';

const RESET = 'home/RESET';


export default {
  FETCH_CURATIONS,
  FETCH_CURATIONS_BANNERS,
  FETCH_STORIES,
  FETCH_SECTIONS,
  REFRESH_STORIES,
  RESET,
};



// WEBPACK FOOTER //
// ./src/app/redux/front/home/types.js